import log from "loglevel";
import { instructorConceptDataActionTypes as types } from "Screens_old";
import InitialState from "Store/InitialState";
import produce from "immer";
import { requestStatusEnum } from "Store/Course/Instructor/Reducer";

export default function instructorConceptDataReducer(
  state = InitialState.instructorConceptDataMap,
  action
) {
  switch (action.type) {
    case types.LOAD_INSTRUCTOR_CONCEPT_DATA_SUCCESS: {
      const { conceptId, data } = action;
      // let instructorConceptDataMap = new Map(state);
      // instructorConceptDataMap.set(conceptId, data);
      // return instructorConceptDataMap;
      return {
        ...state,
        [conceptId]: data,
      };
    }
    case types.DEL_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: {
      const { conceptId, elemType, id } = action;
      let instructorConceptDataMap = { ...state };
      const data = { ...instructorConceptDataMap[conceptId] };
      const newPlaylist = data.playlist.filter((elem) => {
        return elem.type !== elemType || elem.content.id !== id;
      });

      const newData = {
        ...data,
        playlist: newPlaylist,
      };
      // instructorConceptDataMap.set(conceptId, newData);

      return {
        ...state,
        [conceptId]: newData,
      };
    }

    case types.ADD_INSTRUCTOR_CONCEPT_ELEM_REQUEST: {
      return {
        ...state,
        status: requestStatusEnum.RR,
        progress: 0.01
      }
    }

    case types.ADD_INSTRUCTOR_CONCEPT_ELEM_PROGRESS: {
      const progressEvent = action.payload;
      let progress = 0.01

      if (progressEvent.loaded && progressEvent.total) {
        const { loaded, total } = progressEvent
        // log.log({ "Hello": { progressEvent, loaded, total } });
        // progress = ((loaded / total) * 100).toFixed(2);
        // progress += "%";
        progress = loaded / total;
      }
      // log.log({ hello: progress });

      return {
        ...state,
        status: requestStatusEnum.IP,
        progress: progress
      }
    }

    case types.ADD_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: {
      const { conceptId, elemType, content } = action;
      let instructorConceptDataMap = { ...state };
      const data = { ...instructorConceptDataMap[conceptId] };
      let newPlaylist = data.playlist.map((e) => ({ ...e }));
      newPlaylist.push({ type: elemType, content });

      const newData = {
        ...data,
        playlist: newPlaylist,
      };
      return {
        ...state,
        [conceptId]: newData,
        status: requestStatusEnum.S
      };
    }

    case types.ADD_INSTRUCTOR_CONCEPT_ELEM_FAILURE: {
      return {
        ...state,
        progress: 0.01,
        status: requestStatusEnum.F
      }
    }

    case types.RESET_ADD_INSTRUCTOR_CONCEPT_ELEM: {
      return {
        ...state,
        progress: null,
        status: null
      }
    }

    case types.REO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: {
      const { conceptId, playlist } = action;
      let instructorConceptDataMap = { ...state };
      const data = { ...instructorConceptDataMap[conceptId] };

      const newData = {
        ...data,
        playlist,
      };

      return {
        ...state,
        [conceptId]: newData,
      };
    }
    case types.INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: {
      log.log("info");
      const { conceptId, title, description } = action;
      let instructorConceptDataMap = { ...state };
      const data = { ...instructorConceptDataMap[conceptId] };

      const newData = {
        ...data,
        title,
        description,
      };

      return {
        ...state,
        [conceptId]: newData,
      };
    }
    case types.CREATE_QUESTION_MODULE: {
      return produce(state, (draftState) => {
        // draftState.instructorCourseGroupsMap[courseid].push(group);
        // TODO: VERIFY following declaration
        const { id } = action;
        /////////////////////
        const { question_module, conceptId } = action.payload;
        const concept = draftState[conceptId];
        const playlist = concept.playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            if (Array.isArray(draftState[conceptId].playlist[0].content.questionmodule_set))
              draftState[conceptId].playlist[0].content.questionmodule_set.push(question_module);
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            draftState[conceptId].playlist[tempIndex].content.questionmodule_set.push(question_module);
          }
        }
      });
    }

    case types.UPDATE_QUESTION_MODULE: {
      return produce(state, (draftState) => {
        // draftState.instructorCourseGroupsMap[courseid].push(group);
        // TODO: VERIFY following declaration
        const { id } = action;
        /////////////////////
        const { question_module, conceptId } = action.payload;
        const concept = draftState[conceptId];
        const playlist = concept.playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            let questionmodule_set = draftState[conceptId].playlist[0].content.questionmodule_set;
            if (Array.isArray(questionmodule_set)) {
              draftState[conceptId].playlist[0].content.questionmodule_set = questionmodule_set.map(element => {
                if (element.id === question_module.id) {
                  return question_module;
                }
                return element;
              });
            }
            
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            const questionmodule_set = draftState[conceptId].playlist[tempIndex].content.questionmodule_set;
            draftState[conceptId].playlist[tempIndex].content.questionmodule_set = questionmodule_set.map(element => {
              if (element.id === question_module.id) {
                return question_module;
              }
              return element;
            })
          }
        }
      });
    }

    case types.PUBLISH_QUESTION_MODULE: {
      return produce(state, (draftState) => {
        // draftState.instructorCourseGroupsMap[courseid].push(group);
        const { id, conceptId, published } = action.payload;
        const concept = draftState[conceptId];
        const playlist = concept.playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            const question_set = draftState[conceptId].playlist[0].content.question_set;
            draftState[conceptId].playlist[0].content.question_set = question_set?.map(element => {
              if (element.question_module === id) {
                element.is_published = published;
              }
              return element;
            });
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            const question_set = draftState[conceptId].playlist[tempIndex].content.question_set;
            draftState[conceptId].playlist[tempIndex].content.question_set = question_set?.map?.(element => {
              if (element.question_module === id) {
                element.is_published = published;
              }
              return element;
            })
          }
        }
      });
    }

    case types.DELETE_QUESTION_MODULE: {
      return produce(state, (draftState) => {
        const { id, conceptId } = action.payload;
        const playlist = draftState[conceptId].playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            draftState[conceptId].playlist[0].content.questionmodule_set = playlist[0].content.questionmodule_set.filter(element => element.id !== id);
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            draftState[conceptId].playlist[tempIndex].content.questionmodule_set = playlist[tempIndex].content.questionmodule_set.filter(element => element.id !== id);
          }
        }
      })
    }

    case types.CREATE_QUESTION_REQUEST:{
      return produce(state, (draftState) => {
        draftState.addQuestionStatus = requestStatusEnum.RR;
      })
    }

    case types.CREATE_QUESTION_FAILURE:{
      return produce(state, (draftState) => {
        draftState.addQuestionStatus = requestStatusEnum.F;
      })
    }

    case types.CREATE_QUESTION_STATUS_RESET: {
      log.log({addQuestionStatus: "Reseting the status"});
      return produce(state, (draftState) => {
        draftState.addQuestionStatus = "";
      })
    }

    case types.CREATE_QUESTION: {
      return produce(state, (draftState) => {
        // draftState.instructorCourseGroupsMap[courseid].push(group);
        // TODO: VERIFY following declaration
        const { id } = action;
        /////////////////////
        const { question, conceptId } = action.payload;
        const concept = draftState[conceptId];
        const playlist = concept.playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            draftState[conceptId].playlist[0].content.question_set?.push(question);
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            draftState[conceptId].playlist[tempIndex].content.question_set.push(question);
          }
        }
      });
    }

    case types.CREATE_QUESTION_SUCCESS: {
      return produce(state, (draftState) => {
        draftState.addQuestionStatus = requestStatusEnum.S;
      })
    }

    case types.UPDATE_QUESTION: {
      return produce(state, (draftState) => {
        // draftState.instructorCourseGroupsMap[courseid].push(group);
        // TODO: VERIFY following declaration
        const { id } = action;
        /////////////////////
        const { question, conceptId } = action.payload;
        const concept = draftState[conceptId];
        const playlist = concept.playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            const question_set = draftState[conceptId].playlist[0].content.question_set;
            if (Array.isArray(question_set)){
              draftState[conceptId].playlist[0].content.question_set = question_set?.map?.(element => {
                if (element.id === question.id) {
                  return question;
                }
                return element;
              });
            }
            
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            const question_set = draftState[conceptId].playlist[tempIndex].content.question_set;
            draftState[conceptId].playlist[tempIndex].content.question_set = question_set?.map?.(element => {
              if (element.id === question.id) {
                return question;
              }
              return element;
            })
          }
        }
      });
    }

    case types.PUBLISH_QUESTION: {
      return produce(state, (draftState) => {
        // draftState.instructorCourseGroupsMap[courseid].push(group);
        const { id, conceptId, published } = action.payload;
        const concept = draftState[conceptId];
        const playlist = concept.playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            const question_set = draftState[conceptId].playlist[0].content.question_set;
            draftState[conceptId].playlist[0].content.question_set = question_set?.map?.(element => {
              if (element.id === id) {
                element.is_published = published;
              }
              return element;
            });
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            const question_set = draftState[conceptId].playlist[tempIndex].content.question_set;
            draftState[conceptId].playlist[tempIndex].content.question_set = question_set?.map?.(element => {
              if (element.id === id) {
                element.is_published = published;
              }
              return element;
            })
          }
        }
      });
    }

    case types.PUBLISH_ALL_QUESTIONS: {
      return produce(state, (draftState) => {
        // draftState.instructorCourseGroupsMap[courseid].push(group);
        // TODO: VERIFY following declaration
        const { id } = action;
        /////////////////////
        const { conceptId, published } = action.payload;
        const concept = draftState[conceptId];
        log.log({concept, conceptId, draftState});
        const playlist = concept?.playlist;
        log.log({playlist});
        if (playlist) {
          if (playlist.type !== "section") {
            const question_set = draftState[conceptId].playlist[0].content.question_set;
            draftState[conceptId].playlist[0].content.question_set = question_set?.map?.(element => {
              element.is_published = published;
              return element;
            });
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            const question_set = draftState[conceptId].playlist[tempIndex].content.question_set;
            draftState[conceptId].playlist[tempIndex].content.question_set = question_set?.map?.(element => {
              element.is_published = published;
              return element;
            })
          }
        }
      });
    }

    case types.DELETE_QUESTION: {
      return produce(state, (draftState) => {
        const { id, conceptId } = action.payload;
        const playlist = draftState[conceptId].playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            draftState[conceptId].playlist[0].content.question_set = playlist[0].content.question_set.filter(element => element.id !== id);
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === id);
            draftState[conceptId].playlist[tempIndex].content.question_set = playlist[tempIndex].content.question_set.filter(element => element.id !== id);
          }
        }
      })
    }

    case types.UPDATE_QUIZ: {
      return produce(state, (draftState) => {
        const { quizId, data, conceptId } = action.payload;
        const playlist = draftState[conceptId].playlist;
        log.log(playlist)
        if (playlist) {
          if (playlist.type !== "section") {
            draftState[conceptId].playlist[0].content = data;
          } else if (playlist.type === "section") {
            const tempIndex = draftState[conceptId].playlist.findIndex(element => element.id === quizId);
            draftState[conceptId].playlist[tempIndex].content = data;
          }
        }
      })
    }

    default:
      return state;
  }
}
